import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SyncDatabaseService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async syncDatabase(): Promise<void> {
        return await lastValueFrom(
            this.http.put<void>(`${this.domain}/api/sync-database`, {
                headers: this.headers,
            })
        );
    }
}
